// composables/use-v-toast.js
import { notification } from 'ant-design-vue'

// Configuration defaults
const DEFAULT_DURATION = 3 // seconds
const DEFAULT_PLACEMENT = 'top'
const Z_INDEX = 999999

// Configure global notification defaults
notification.config({
  duration: DEFAULT_DURATION,
  placement: DEFAULT_PLACEMENT,
  getContainer: () => {
    // 建立一個自訂容器，自己加 style
    const el = document.createElement('div')
    el.id = 'custom-notification-root'
    el.style.zIndex = '999999'   // ✅ 直接加 style
    el.style.position = 'relative'
    document.body.appendChild(el)
    return el
  }
})

export default function useVToast(options) {
  if (!options) {
    throw new Error('useVToast requires options object')
  }

  const {
    title,
    message = title,
    description = '',
    type = 'info',
    placement = DEFAULT_PLACEMENT,
    duration = DEFAULT_DURATION,
    ...restOptions
  } = options

  const config = {
    message,
    description,
    placement,
    duration,
    style: { 'z-index': Z_INDEX},
    ...restOptions
  }

  // Use the appropriate notification type method
  switch (type) {
    case 'success':
      notification.success(config)
      break
    case 'error':
      notification.error(config)
      break
    case 'warning':
      notification.warning(config)
      break
    case 'info':
    default:
      notification.info(config)
      break
  }
}

// Add a utility method to close all notifications
useVToast.closeAll = () => {
  notification.destroy()
}
